"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGenerateBulletsResponse = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateGenerateBulletsResponse = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    message: (0, validation_1.text)(),
});
//# sourceMappingURL=GenerateBulletsResult.js.map